import { CmsMediaFile } from '@internal/utils/media/Media';
import { Text } from '@renderer-ui-library/atoms';
import { Typography } from '@renderer-ui-library/mui';
import { Media } from '../Media/Media';
import styles from './benefitCard.module.scss';

type Props = {
    headline: string;
    description: string;
    image: CmsMediaFile;
    cta: string;
};

export const BenefitCard: React.FC<Props> = props => {
    const { headline, description, image, cta } = props;

    return (
        <div className={styles.cardWrapper}>
            <div className={styles.image}>
                <Media media={image} ratio={4 / 3} sizeSet="medium" />
            </div>
            <Typography variant="h4" margin={'24px 0'}>
                {headline}
            </Typography>
            <div className={styles.description}>
                <Text text={description} variant="body1" />
            </div>
            <div className={styles.ctaWrapper}>
                <Text text={cta} variant="body1" />
            </div>
        </div>
    );
};

BenefitCard.displayName = 'BenefitCard';
